import {
  inject, provide, getCurrentInstance, onUnmounted,
} from 'vue';
import { usePostRef } from 'use-api-vue';

import keyRoutesEnum from '@/router/keyRoutesEnum';

const PROVIDE_UNIQUE_NAME = 'USE_LOGOUT';

type logoutType = ReturnType<typeof usePostRef>;

export const useLogoutProvider = (): void => {
  const result = usePostRef({ onCancelCallback: onUnmounted });
  provide(PROVIDE_UNIQUE_NAME, result);
};

const useLogout = () => {
  const vm = getCurrentInstance()?.proxy;

  if (!vm) {
    throw new Error(
      'vue-query hooks can only be used inside setup() function.',
    );
  }
  const provider = inject<logoutType>(PROVIDE_UNIQUE_NAME);
  if (!provider) {
    throw new Error(
      "No apiClient found in Vue context, use 'useLogoutProvider' to set one in the root component.",
    );
  }
  const { error, loading, send } = provider;

  const onLogout = async () => {
    await send('logout');
    window.location.href = keyRoutesEnum.login;
  };

  return {
    error,
    loading,
    onLogout,
  };
};

export default useLogout;
